<template>
  <v-col class="align-self-center">
    <v-row
      v-if="showProgress"
      class="justify-center text-center"
    >
      <v-progress-circular
        :size="70"
        color="#055289"
        indeterminate
      />
    </v-row>

    <v-row
      v-if="currentMessage && currentMessage.type === 'error'"
      class="justify-center text-center"
    >
      <v-icon
        color="toasted"
        size="70"
      >
        error_outline
      </v-icon>
    </v-row>

    <v-row
      v-if="currentMessage && currentMessage.type === 'info'"
      class="justify-center text-center"
    >
      <v-icon
        color="primary"
        size="70"
      >
        info_outline
      </v-icon>
    </v-row>

    <v-row
      v-if="isInfoOrError"
      class="subtitle-2 justify-center pt-3"
    >
      <span>
        {{ currentMessage.text }}
      </span>
    </v-row>

    <v-row
      v-else
      class="caption justify-center pt-3"
    >
      <span>
        {{ currentMessage.text }}
      </span>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('messages')

export default {
  name: 'MessageView',
  computed: {
    ...mapGetters(['currentMessage']),
    isInfoOrError() {
      return this.currentMessage && ['error', 'info'].indexOf(this.currentMessage.type) !== -1
    },
    showProgress() {
      return !this.currentMessage || !this.isInfoOrError
    },
  },
}
</script>
